// Unlisted customer pages (/docs/*: setup guides, the clinician walkthrough). They are not marketing:
// no announcement bar, no sales voice agent, and no demo button in the header (Contact stays in the nav).
export const isCustomerPage = (pathname: string | null | undefined) => !!pathname && pathname.startsWith('/docs/');
